let btns = document.querySelectorAll('[data-location-btn]');

btns.forEach (btn => {
    btn.addEventListener('click', () => {
        let locationContent = document.querySelectorAll('[data-location-content]');

        locationContent.forEach(content => {
            content.classList.remove('active');
        });

        let location = document.querySelector(`[data-location-content="${btn.getAttribute('data-location-btn')}"]`);
        location.classList.add('active');
    });
});

